import { isAuthenticationRequiredSyncError } from '@/lib/sync/error-utils';
import { syncPlayerEvents } from '@/lib/sync/player-events';
import type { UserId } from '@/schemas/ids';
import { enqueueSyncJob, registerSyncPlugin } from '../plugins.js';
import type { SyncPlugin } from '../plugins.js';

export const PLAYER_EVENTS_SYNC_PLUGIN_KEY = 'player-events';

const playerEventsPlugin: SyncPlugin<UserId> = {
  key: PLAYER_EVENTS_SYNC_PLUGIN_KEY,
  createJobKey(userId: UserId) {
    return `player-events:${String(userId)}`;
  },
  createMetadata(userId: UserId) {
    return {
      entity: 'player-events',
      scope: String(userId),
      source: 'player-events-sync-plugin',
    };
  },
  async run(userId: UserId) {
    await syncPlayerEvents(userId);
  },
  shouldRetry(error) {
    return !isAuthenticationRequiredSyncError(error);
  },
};

const registerPlayerEventsPlugin = registerSyncPlugin as (
  plugin: SyncPlugin<UserId>,
) => SyncPlugin<UserId>;
registerPlayerEventsPlugin(playerEventsPlugin);

export function enqueuePlayerEventsSync(userId: UserId): void {
  const enqueue = enqueueSyncJob as (key: string, scope: UserId) => void;
  enqueue(PLAYER_EVENTS_SYNC_PLUGIN_KEY, userId);
}
